import { BrowserUtils } from '@azure/msal-browser';
import { KsbProvider } from '@ksb/ui';
import '@ksb/ui/design.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { ApiFehlerError, setzeAnmeldeHeader } from './api/client';
import { holeAccessToken } from './auth/accessToken';
import { entwicklungsHeader, istEntwicklungsLogin } from './auth/entwicklungsLogin';
import { initialisiereMsal } from './auth/msalInstanz';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Fachliche Fehler (4xx) nicht wiederholen, nur Netzwerk-/Serverfehler
      retry: (anzahl, err) => !(err instanceof ApiFehlerError && err.status < 500) && anzahl < 2,
      refetchOnWindowFocus: true,
    },
  },
});

/**
 * Wie bei Axis: MSALs verstecktes iframe für die stille Token-Erneuerung lädt dieselbe
 * Adresse wie die App. In diesem Fall nur die Antwort an das Hauptfenster melden und
 * nicht die ganze App im iframe starten (sonst Timeout trotz erfolgreicher Anmeldung).
 */
if (!istEntwicklungsLogin && BrowserUtils.isInIframe()) {
  const { broadcastResponseToMainFrame } = await import('@azure/msal-browser/redirect-bridge');
  await broadcastResponseToMainFrame();
} else {
  if (istEntwicklungsLogin) {
    setzeAnmeldeHeader(async () => entwicklungsHeader());
  } else {
    // Vor dem ersten Render: der erste Aufruf (/api/me) braucht bereits ein Token.
    await initialisiereMsal();
    setzeAnmeldeHeader(async () => ({ Authorization: `Bearer ${await holeAccessToken()}` }));
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <KsbProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </KsbProvider>
    </StrictMode>,
  );
}
